import { Grid, makeStyles } from '@material-ui/core';
import React, { useState } from 'react';
import { CircularIcon, Colors, Text } from 'library';
import { IRow } from '../models';

interface IProps {
    rows: IRow[];
}

const useStyles = makeStyles({
    root: {
        backgroundColor: 'white',
        cursor: 'pointer',
        flexWrap: 'nowrap',
        borderRadius: 18,
        '&:hover': {
            backgroundColor: Colors.lightTurq,
        },
    },
});

export default function InviteMenu({ rows }: IProps) {
    const classes = useStyles();

    const Row = ({ row, index }: { row: IRow; index: number }) => {
        return (
            <Grid
                classes={classes}
                style={{
                    marginBottom: index === rows.length - 1 ? 0 : 15,
                }}
                container
                item
                spacing={1}
                onClick={row.action}
            >
                <Grid item>
                    <CircularIcon icon={row.icon} backgroundColor={Colors.lightTurq} style={{ padding: 7 }} />
                </Grid>
                <Grid item>
                    <Grid container direction="column">
                        <Text variant="body1" bold>
                            {row.title}
                        </Text>
                        <Text variant="body2">{row.subtitle}</Text>
                    </Grid>
                </Grid>
            </Grid>
        );
    };

    return (
        <Grid container item direction="column">
            {rows.map((row, index) => {
                return <Row row={row} index={index} />;
            })}
        </Grid>
    );
}
